// The only event names the app may send. Anything not listed here is rejected by trackEvent, so a
// typo can't quietly create a parallel event that nobody notices until a report looks wrong.
//
// Naming: `Object Action` in Title Case, one event meaning one thing. Names are expensive to change
// later -- reports, funnels and boards are built on them -- so add deliberately. The wider list we
// proposed to product lives in tickets/mixpanel-web-integration.md; names land here when wired.
export const EVENTS = {
  SIGNUP_PAGE_VIEWED: 'Signup Page Viewed',
  SIGNUP_PATH_SELECTED: 'Signup Path Selected',
  // Account Created is reported by the backend (User after_create_commit) -- the client sees only
  // web self-registrations and never sees `origin`, so it cannot do that job.
  SIGNED_IN: 'Signed In',
}

export const EVENT_NAMES = Object.values(EVENTS)
